function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import isClient from './util/detectClient';
import request from './util/request';
import configurable from './util/configurable';
import { Config, HB_SESSION_ID_KEY } from './util/config';
import cookie from './util/cookie';
import { camelToUnder } from './util/json';

// 上报字段设计文档
// https://doc.baijia.com/sheets/qeK4Xdxva72RSLWM/y7NM8

var HB_SESSION_ID_VALUE = cookie.get(HB_SESSION_ID_KEY);

/**
 * 业务手动上报日志
 *
 * @function
 * @param {Object} json 要上报的数据
 * @param {Function=} callback 上报后的回调
 */

var report = configurable(function (json, callback) {
  if (!isClient) {
    return;
  }

  // 多取几次appNid是为了兼容历史传参情况
  var appNid = Config.APPNID || Config.appNid || Config.appId;
  var type = json.type,
    level = json.level;
  if (appNid && type && level) {
    Object.assign(json, _defineProperty({}, HB_SESSION_ID_KEY, HB_SESSION_ID_VALUE || cookie.get(HB_SESSION_ID_KEY)));
    var reportData = _objectSpread({
      actionStart: Date.now(),
      appNid: appNid,
      reqType: 'log'
    }, json);
    request(Config.VERB)("".concat(Config.LOG), camelToUnder(reportData), callback);
  }
}, {});
var Logger = /*#__PURE__*/function () {
  function Logger() {
    _classCallCheck(this, Logger);
    this.type = 'NORMAL';
    this.level = 'NORMAL';

    /**
     * 日志级别 level
     * 0-'NORMAL',  普通
     * 1-'URGENT',  紧急
     * 2-'CRITICAL', 严重
     * 3-'MINIMAL', 轻微
     */
    this.levelList = ['NORMAL', 'URGENT', 'CRITICAL', 'MINIMAL'];

    /**
     * 类型映射
     * type
     * 0-NORMAL 普通日志
     * 1-STATIC_RESOURCE 静态资源
     * 2-JAVASCRIPT js执行
     * 3-HTTP_REQUEST 接口请求
     * 4-PAGE_BLANK 白屏
     * 5-BUSINESS 业务自定义
     */
    this.typeList = ['NORMAL', 'STATIC_RESOURCE', 'JAVASCRIPT', 'HTTP_REQUEST', 'PAGE_BLANK', 'BUSINESS'];
  }

  /**
   * 设置日志级别
   *
   * @param {string} levelDesc 日志级别
   */
  _createClass(Logger, [{
    key: "setLevel",
    value: function setLevel() {
      var levelDesc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'NORMAL';
      this.level = "".concat(this.levelList.findIndex(function (level) {
        return levelDesc === level;
      }));
    }

    /**
     * 设置日志类型
     *
     * @param {string} typeDesc 日志类型
     */
  }, {
    key: "setType",
    value: function setType() {
      var typeDesc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'NORMAL';
      this.type = "".concat(this.typeList.findIndex(function (type) {
        return typeDesc === type;
      }));
    }

    /**
     * 自己设置上报日志
     *
     * @param {Object} info 日志相关参数
     * @param {string} info.level 日志级别
     * @param {string} info.type 日志类型
     * @param {string} info.description 日志描述信息
     * @param {Object} info.extra 日志补充信息
     */
  }, {
    key: "log",
    value: function log(info) {
      var _info$level = info.level,
        level = _info$level === void 0 ? 'NORMAL' : _info$level,
        _info$type = info.type,
        type = _info$type === void 0 ? 'NORMAL' : _info$type,
        _info$description = info.description,
        description = _info$description === void 0 ? '' : _info$description,
        _info$extra = info.extra,
        extra = _info$extra === void 0 ? {} : _info$extra;
      this.setLevel(level);
      this.setType(type);
      if (this.isLogValid(info)) {
        report({
          level: this.level,
          type: this.type,
          description: JSON.stringify(description),
          extra: JSON.stringify(extra)
        });
      }
    }

    /**
     * 发送 NORMAL 级别的日志
     *
     * @param {Object} params 日志参数
     */
  }, {
    key: "info",
    value: function info(params) {
      this.setLevel('NORMAL');
      this.sendReport(params);
    }

    /**
     * 发送 MINIMAL 级别的日志
     *
     * @param {Object} params 日志参数
     */
  }, {
    key: "warn",
    value: function warn(params) {
      this.setLevel('MINIMAL');
      this.sendReport(params);
    }

    /**
     * 发送 CRITICAL 级别的日志
     *
     * @param {Object} params 日志参数
     */
  }, {
    key: "error",
    value: function error(params) {
      this.setLevel('CRITICAL');
      this.sendReport(params);
    }

    /**
     * 发送 URGENT 级别的日志
     *
     * @param {Object} params 日志参数
     */
  }, {
    key: "fatal",
    value: function fatal(params) {
      this.setLevel('URGENT');
      this.sendReport(params);
    }

    /**
     * 检查日志level type 是否可以满足发送要求
     *
     * @param {Object} params 日志配置参数
     */
  }, {
    key: "isLogValid",
    value: function isLogValid(params) {
      var errTitle = '【哈勃】【log】参数有误，可能导致无法正常上报日志\r\n';
      if (+this.level < 0) {
        console.error(errTitle, '参数中的 level 为：', params.level, '\r\n', "\u9884\u671F\u7684 level \u4E3A ".concat(this.levelList.join(','), " \u5176\u4E2D\u4E4B\u4E00\r\n"));
        return false;
      }
      if (+this.type < 0) {
        console.error(errTitle, '参数中的 type 为：', params.type, '\r\n', "\u9884\u671F\u7684 type \u4E3A ".concat(this.typeList.join(','), " \u5176\u4E2D\u4E4B\u4E00\r\n"));
        return false;
      }
      return true;
    }

    /**
     * 发送日志,用于提前设置好 level 的场景
     *
     * @param {Object} params 日志参数
     * @private
     */
  }, {
    key: "sendReport",
    value: function sendReport(params) {
      var _params$type = params.type,
        type = _params$type === void 0 ? '' : _params$type,
        _params$description = params.description,
        description = _params$description === void 0 ? '' : _params$description,
        _params$extra = params.extra,
        extra = _params$extra === void 0 ? {} : _params$extra;
      type && this.setType(type);
      if (this.isLogValid()) {
        report({
          description: JSON.stringify(description),
          extra: JSON.stringify(extra),
          type: this.type,
          level: this.level
        });
      }
    }
  }]);
  return Logger;
}();
export default Logger;